import React, { PropTypes } from "react";
import ComponentRegistry from "Fratello/Common/ComponentRegistry";

function Products({ productView, products, compare }) {
    const ProductView = ComponentRegistry.get(productView);

    return (
      <section className="widget widget-products clearfix">{Object.values(products).map(
          (product, index) => <ProductView key={index} {...product} compare={compare} />
        )}</section>
    );
}

Products.propTypes = {
    productView: PropTypes.string.isRequired,
    products: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default function ProductsView(props) {
    const Header = ComponentRegistry.get("ProductBrowserAtomsHeader");
    const Footer = ComponentRegistry.get("ProductBrowserAtomsFooter");
    if(props.status === 'loading' ) {
        return (<section className="panel panel-preload"><div className="inner"><i className="icon icon-loader"></i><span className="text">Ogenblikje...</span></div></section>);
    }
    return (
      <div className="product-browser">
          <div className="row">
              <Products {...props} />
          </div>
        <Footer {...props} />
      </div>
    );
}

ProductsView.propsTypes = {};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/ProductBrowser/Views/ProductsView.jsx